/* eslint-disable react/jsx-max-props-per-line, react/jsx-one-expression-per-line */
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from 'src/components/ui/sheet';
import type { BillingImportDTO } from '../types/pipeline.types';

type ImportDetailSheetProps = {
  readonly open: boolean;
  readonly onOpenChange: (open: boolean) => void;
  readonly row: BillingImportDTO | null;
};

export function ImportDetailSheet({ open, onOpenChange, row }: ImportDetailSheetProps) {
  if (!row) {
    return null;
  }

  const rawJson = row.raw_data != null ? JSON.stringify(row.raw_data, null, 2) : '—';

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full sm:max-w-xl md:max-w-2xl overflow-y-auto">
        <SheetHeader>
          <SheetTitle>Import #{row.id}</SheetTitle>
          <SheetDescription>
            {row.source} · {row.status}
            {row.error_message ? ` · ${row.error_message}` : ''}
          </SheetDescription>
        </SheetHeader>
        <div className="mt-4 space-y-4 text-sm">
          <dl className="grid grid-cols-2 gap-2">
            <dt className="text-gray-500">Started</dt>
            <dd>{row.started_at ?? '—'}</dd>
            <dt className="text-gray-500">Completed</dt>
            <dd>{row.completed_at ?? '—'}</dd>
            <dt className="text-gray-500">Attempt</dt>
            <dd>{row.attempt}</dd>
            <dt className="text-gray-500">Batch</dt>
            <dd>{row.batch_id ?? '—'}</dd>
            <dt className="text-gray-500">Correlation</dt>
            <dd className="break-all">{row.correlation_id ?? '—'}</dd>
          </dl>
          <div>
            <h3 className="font-medium text-gray-900 mb-2">raw_data (read-only)</h3>
            <pre className="max-h-[60vh] overflow-auto rounded-md bg-gray-900 p-3 text-xs text-gray-100 whitespace-pre-wrap break-words">
              {rawJson}
            </pre>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
